import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiEndpoints } from '../api/api-endpoints';

interface UserProfileImageResponse {
  profileImageUrl?: string;
  profile_image_url?: string;
  profilePhotoUrl?: string;
  profile_photo_url?: string;
  avatarUrl?: string;
  avatar_url?: string;
}

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  private readonly http = inject(HttpClient);

  getProfileImageUrl(): Observable<string> {
    return this.http
      .get<UserProfileImageResponse>(ApiEndpoints.userProfile)
      .pipe(
        map(
          (profile) =>
            profile.profileImageUrl ??
            profile.profile_image_url ??
            profile.profilePhotoUrl ??
            profile.profile_photo_url ??
            profile.avatarUrl ??
            profile.avatar_url ??
            '',
        ),
      );
  }
}
